import { initialTheme } from "../../reducer/admin/themeReducer";
import * as themeTypes from "../../types/admin/themeTypes";
import axios from "axios";
export const themeAction =
  (noTheme, onlyLoading) => async (dispatch, getState) => {
    try {
      if (!onlyLoading) {
        dispatch({
          type: themeTypes.THEME_REQUEST,
          payload: {
            info: {
              ...initialTheme.info,
              newConfig: {
                ...initialTheme.info.newConfig,
              },
              status: "loading",
            },
          },
        });
        const {
          sharedLogin: { sharedUserInfo },
        } = getState();

        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${sharedUserInfo?.payload?.token}`,
          },
        };

        let companyId;
        if (sharedUserInfo?.payload?.company) {
          companyId = sharedUserInfo?.payload?.company?._id;
        } else if (sharedUserInfo?.empCompanies.length > 0) {
          companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
        }
        if (noTheme) {
          dispatch({
            type: themeTypes.THEME_SUCCESS,
            payload: {
              info: {
                ...initialTheme.info,
                newConfig: {
                  ...initialTheme.info.newConfig,
                },
                status: "loaded",
              },
            },
          });
          return initialTheme;
        } else {
          const { data } = await axios.get(
            `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/theme-settings/get`,
            config
          );
          dispatch({
            type: themeTypes.TOGGLE_THEME_LOADING_SUCCESS,
          });
          dispatch({
            type: themeTypes.THEME_SUCCESS,
            payload: { ...data.data, status: "loading" },
          });
          return data?.data;
        }

        // if (data.success && data.data) {
        //   dispatch({
        //     type: themeTypes.THEME_SUCCESS,
        //     payload: data.data,
        //   });
        // } else {
        //   // No theme found, set the default theme

        // }

        // return data?.data || initialTheme;
      } else {
        dispatch({
          type: themeTypes.THEME_SUCCESS,
          payload: {
            info: {
              ...initialTheme.info,
              newConfig: {
                ...initialTheme.info.newConfig,
                state: "loading",
              },
            },
          },
        });
        dispatch({
          type: themeTypes.TOGGLE_THEME_LOADING_SUCCESS,
        });
        return initialTheme;
      }
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: themeTypes.THEME_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
export const themeCreateAction =
  (themeData, notApi) => async (dispatch, getState) => {
    try {
      dispatch({
        type: themeTypes.CREATE_THEME_REQUEST,
      });
      dispatch({
        type: themeTypes.THEME_REQUEST,
        payload: {
          info: {
            ...initialTheme.info,
            newConfig: {
              ...initialTheme.info.newConfig,
            },
            status: "loading",
          },
        },
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let dataApi = {};
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      if (notApi) {
        const asd = { ...themeData, ...dataApi };
        dispatch({
          type: themeTypes.THEME_SUCCESS,
          payload: {
            ...asd,
            info: {
              ...asd.info,
              status: "loaded",
            },
          },
        });
        dispatch({
          type: themeTypes.CREATE_THEME_STOP_LOADING,
        });
      } else {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/theme-settings/create`,
          themeData,
          config
        );
        dataApi = data?.data;
        const asd = { ...themeData, ...dataApi };
        dispatch({
          type: themeTypes.CREATE_THEME_SUCCESS,
          payload: asd,
        });
        dispatch({
          type: themeTypes.THEME_SUCCESS,
          payload: {
            ...asd,
            info: {
              ...asd?.info,
              status: "loaded",
            },
          },
        });
      }
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      console.log(error);
      dispatch({
        type: themeTypes.CREATE_THEME_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
export const breadCrumbsAction = (crumbData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: themeTypes.CRUMB_REQUEST,
    });

    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    // Example API call
    // const { data } = await axios.post(
    //   `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/idle/${userId}/${departId}`,
    //   body,
    //   config
    // );

    dispatch({
      type: themeTypes.CRUMB_SUCCESS,
      payload: crumbData,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);

    if (!err) {
      err = "Network Error";
    }

    dispatch({
      type: themeTypes.CRUMB_FAIL,
      payload: err,
    });
    throw new Error(err);
  }
};

export const toggleDrawerAction = (value) => async (dispatch) => {
  try {
    dispatch({ type: themeTypes.TOGGLE_DRAWER_REQUEST });
    dispatch({
      type: themeTypes.TOGGLE_DRAWER_SUCCESS,
      payload: value,
    });
  } catch (error) {
    dispatch({
      type: themeTypes.TOGGLE_DRAWER_FAIL,
      payload: error.message || "Something went wrong",
    });
  }
};
export const toggleThemeLoadingAction = (value, msg) => async (dispatch) => {
  try {
    dispatch({ type: themeTypes.TOGGLE_THEME_LOADING_REQUEST });
    dispatch({
      type: themeTypes.TOGGLE_THEME_LOADING_SUCCESS,
      payload: value,
    });
  } catch (error) {
    dispatch({
      type: themeTypes.TOGGLE_THEME_LOADING_FAIL,
      payload: error.message || "Something went wrong",
    });
  }
};
